var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 199.7",
    style: {
      enableBackground: "new 0 0 256 199.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.6,11.4c-2.7,1-4.5,2.7-5.2,5c-0.3,1.2-0.5,15.5-0.5,37.1v35.2H83.6H63V77.5V66.3l-1.6-1.6 c-1.4-1.3-2-1.6-3.4-1.3c-1.3,0.2-8.7,5.3-24.3,16.6C21.5,89,11,96.7,10.6,97.2c-0.4,0.4-0.6,1.7-0.6,2.7s0.3,2.2,0.6,2.7 c0.4,0.4,10.8,8.2,23.2,17.2c20.3,14.7,22.8,16.4,24.7,16.4c1.6,0,2.3-0.3,3.3-1.4c1.3-1.5,1.3-1.6,1.3-12.7V111h20.5h20.3v35.2 c0,21.6,0.2,36,0.5,37.2c2,7.1,12.9,7.1,14.9-0.1c0.3-1.2,0.5-29.3,0.4-84.6c-0.2-82.6-0.2-82.7-1.3-84.2 C116.1,11.3,113.1,10.2,109.6,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.9,11.1c-2.2,0.5-4.3,2.3-5.2,4.6c-1.1,2.6-1.1,165.7,0,168.3c2.4,5.8,10.5,6.4,14,1.1 c0.9-1.3,1-4.1,1.1-37.7l0.2-36.3h18.8h18.9v11.2v11.2l1.6,1.6c1.4,1.3,2,1.6,3.4,1.3c1.2-0.2,8.6-5.3,23.5-16 c12-8.7,22.4-16.4,23.2-17.2c2-1.9,2-4.7,0-6.6c-0.9-0.7-11.3-8.5-23.2-17.2c-14.8-10.7-22.3-15.9-23.5-16c-1.4-0.3-2,0-3.4,1.3 l-1.6,1.6v11.2v11.2h-18.9h-18.8l-0.2-36.4c-0.2-36-0.2-36.4-1.3-37.9C151.6,11.7,148.1,10.4,144.9,11.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitup);
export default __webpack_public_path__ + "static/media/splitup.40b55ab8fe1351d1a48b9ce5fbaf7649.svg";
export { ForwardRef as ReactComponent };